import { CESIUM_API_KEY, GOOGLE_MAP_API_KEY } from '@/constants/env';
import { Viewer2DHandleBuilder } from '@/next/Viewer2DHandle/Viewer2DHandleBuilder';
import { ViewerHandleBuilder as Viewer3DHandleBuilder } from '@skand/viewer-component-v2';
import { setViewer3DHandle } from './viewer';

const viewer2DHandleBuilder = new Viewer2DHandleBuilder();
export const viewer2DHandle = viewer2DHandleBuilder.build();
viewer2DHandle.start();

const viewerHandleBuilder = new Viewer3DHandleBuilder({
  cesiumToken: CESIUM_API_KEY,
  googleToken: GOOGLE_MAP_API_KEY,
  gameServerUrl: 'https://explore-game-server.onrender.com',
});

viewerHandleBuilder.build().then(viewer3DHandle => {
  viewer3DHandle.start();
  setViewer3DHandle(viewer3DHandle);
});
